
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icons / chevron - right","xmlns":"http://www.w3.org/2000/svg","width":"6.947","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.277.277A.948.948 0 011.511.186l.106.092L6.67 5.33a.948.948 0 01.092 1.234l-.092.106-5.053 5.053a.947.947 0 01-1.431-1.234l.092-.106L4.66 6 .277 1.617A.948.948 0 01.186.384z","fill":"#fc6b36"}})])
          )
        }
      }
    